import { Grid } from '@material-ui/core';
import { connect } from 'formik';
import { Field } from 'formik';
import { agent } from 'helpers/agent';
import React, { useState, useEffect } from 'react';
import { API_MYEDUZZ } from 'settings';
import createShowIf from 'v2/components/Shared/createShowIf';
import { DatePickerFormField } from 'v2/components/Shared/FormFields/DatePickerFormField';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

import { EChargeType } from '../../classes/Product';

import type { Payments } from '../../classes/Payment';
import type { ICurrency } from '../../classes/Product';

interface IProps extends IForm<Payments> {}

const Single = (props: Partial<IProps>) => {
  const { values } = props.formik;
  const { setFocus } = props;
  const [currencies, setCurrencies] = useState([]);

  const fetchData = async () => {
    const result = await agent.get(`${API_MYEDUZZ}/currencies`);
    setCurrencies(result.data.data);
  };

  const listCurrencies = currencies.map((currency: ICurrency) => {
    return { label: `${currency.code} - ${currency.name}`, value: currency.id };
  });

  const ShowIfPayments = createShowIf<Payments>();

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ShowIfPayments value={values} compare={{ eq: { charge_type: EChargeType.SINGLE } }}>
      <Grid item xs={12}>
        <Field
          label='Moeda'
          id='currency.id'
          name='currency.id'
          component={SelectFormField}
          options={listCurrencies.filter((currency) => currency.value === 1)}
          selected={1}
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <Field label='Preço' name='price' id='price' mask='money' onFocus={setFocus} component={TextFormField} />
      </Grid>
      <Grid item xs={12}>
        <Field id='has_promotional_price' name='has_promotional_price' label='O produto tem preço promocial ?' component={SwitchFormField} />
      </Grid>
      <ShowIfPayments value={values} compare={{ eq: { has_promotional_price: true } }}>
        <Grid item xs={12}>
          <Field
            label='Preço promocional'
            name='promotional_price'
            id='promotional_price'
            mask='money'
            onFocus={setFocus}
            component={TextFormField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            id='date_promotional_price'
            name='date_promotional_price'
            label='Validade do preço promocional'
            disablePast
            component={DatePickerFormField}
          />
        </Grid>
      </ShowIfPayments>
    </ShowIfPayments>
  );
};

export default connect(Single);
